module.exports = __webpack_public_path__ + "static/media/Kongi1-08.637db0f4.png";